import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const _6kPlusIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"6k_plus"} ref={ref}/>
});

_6kPlusIcon.displayName = "_6kPlusIcon";
